import { TitreTexteInfo } from '@components/titre-texte-info/models';
import { Block } from '@shared/models';

export const titreTexteInfoMock: Block<TitreTexteInfo> = {
  type: 'titre-texte-info',
  data: {
    title: {
      text: 'Je prépare ma pièce et [[mon matériel]]',
      as: 'h2',
    },
    text: `<p>Pour préparer votre pose, commencez par rassembler les outils suivants : crayon, vis, équerre de fixation, équerres pour mesurer, scotch alu, scotch, tournevis, serre-joint, multiprise, niveau à huile, tasseaux, grande règle, cutter, colle blanche, silicone anti fongique, ciseaux, perceuse + mèche à bois, colle néoprène, lime fine, clé plate ou à cliquet, escabeau, visseuse, scie à métaux, scie sauteuse, scie circulaire, maillet caoutchouc, tréteaux, mètre.</p><p>Pour certains outils n’hésitez pas à demander à votre entourage ou à les louer pour être prêt le jour du montage de votre cuisine équipée. Nous vous rappelons que c’est à vous de prévoir toutes les fixations adaptées à vos murs.</p>`,
    infoCard: `Les peintures, tapisseries et sols de votre espace cuisine doivent être fait avant la pose. Les arrivées d’eau et d’électricité doivent être fonctionnelles et respecter le plan donné par le magasin.`,
  },
};
